import React from 'react';
import { NextSeo } from 'next-seo';
import TalBanner from '../components/common/Banner';
import productionList from '../data/openAbility.json';
import FunctionIntroduction from '../components/product/FunctionIntroduction';
import ApplicationScenarios from '../components/product/ApplicationScenarios';
import FunctionalExperience from '../components/product/FunctionalExperience';
import TechAdvantage from '../components/product/TechAdvantage';
import RelatedRecommend from '../components/product/RelatedRecommend';
import LookingForwardToCooperation from '../components/common/LookingForwardToCooperation';
import Err404 from '@/components/common/404';

const Product = ({ productionInfo, err404 }) => {
  if (err404) {
    return <Err404 />;
  }
  return (
    <>
      <NextSeo title={`好未来AI开放平台-${productionInfo.title}`} />
      <TalBanner
        image={productionInfo.image}
        desc={productionInfo.desc}
        title={productionInfo.title}
        tryLink={{
          show: !!productionInfo.freeTryUrl,
          content: '免费试用',
          index: 0
        }}
        docLink={{
          to: productionInfo.techDocUrl,
          content: productionInfo.techDocUrl ? '技术文档' : ''
        }}
        link={{
          to: productionInfo.cooperationUrl,
          content: productionInfo.cooperationUrl ? '合作咨询' : ''
        }}
      />
      <FunctionIntroduction
        title="功能介绍"
        list={productionInfo.functionIntroList}
      />
      {productionInfo.scenesLists.length > 0 && (
        <ApplicationScenarios
          title="应用场景"
          contents={productionInfo.scenesLists}
        />
      )}
      {productionInfo.ability ? (
        <FunctionalExperience title="功能体验" production={productionInfo} />
      ) : null}
      <TechAdvantage title="技术优势" list={productionInfo.techLists} />
      {productionInfo.relatedRecommendList &&
        productionInfo.relatedRecommendList.length > 0 && (
          <RelatedRecommend
            title="相关推荐"
            list={productionInfo.relatedRecommendList}
          />
        )}
      <LookingForwardToCooperation
        freeTrial={{ show: !!productionInfo.freeTryUrl, button: '免费试用' }}
        cooperationConsulting={{
          to: productionInfo.cooperationUrl,
          button: '合作咨询'
        }}
      />
    </>
  );
};

Product.getInitialProps = (ctx) => {
  const { name: produtionName } = ctx.query;
  const productionInfo = productionList.find((p) => p.name === produtionName);
  return {
    productionInfo,
    err404: !productionInfo
  };
};

export default Product;
